// extracted by mini-css-extract-plugin
export default {"createEditTemplateContainer":"CreateEditTreatmentPlanTemplate_createEditTemplateContainer__XwVXk"};